import { render, staticRenderFns } from "./imageComponent.vue?vue&type=template&id=5ca9afb1&scoped=true&"
import script from "./imageComponent.vue?vue&type=script&lang=js&"
export * from "./imageComponent.vue?vue&type=script&lang=js&"
import style0 from "./imageComponent.vue?vue&type=style&index=0&id=5ca9afb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca9afb1",
  null
  
)

export default component.exports